// frontend/src/services/testService.js

import axios from 'axios';

const API_URL = '/api';

// Crear una instancia de axios configurada (opcional pero recomendado)
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const testService = {
  verifyToken: async (token) => {
    try {
      const response = await axios.get(`${API_URL}/test/verify/${token}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al verificar el token' };
    }
  },

  getReactivos: async (prueba_id) => {
    try {
      const response = await axios.get(`${API_URL}/test/reactivos/${prueba_id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al obtener las preguntas' };
    }
  },

  getSeries: async (prueba_id) => {
    try {
      const response = await axios.get(`${API_URL}/test/series/${prueba_id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al obtener las series' };
    }
  },

  saveRespuesta: async (token, reactivo_id, respuesta, tiempo_ms, seccion_id = null) => {
    try {
      const response = await axios.post(`${API_URL}/test/respuesta`, {
        token,
        reactivo_id,
        respuesta,
        tiempo_ms,
        seccion_id  // Añadido para Cleaver
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al guardar la respuesta' };
    }
  },

  finalizarTest: async (token) => {
    try {
      const response = await axios.post(`${API_URL}/test/finalizar`, { token });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al finalizar la prueba' };
    }
  },

  // Avisa al backend que ya no hay nada más que mostrarle al candidato en
  // esta prueba (aunque no se haya respondido el 100%, p. ej. Terman por
  // límite de tiempo), para que /verify deje de reportarla como en_progreso.
  finalizarPrueba: async (token, prueba_id) => {
    try {
      const response = await axios.post(`${API_URL}/test/finalizar-prueba`, { token, prueba_id });
      return response.data;
    } catch (error) {
      console.error('Error al marcar prueba como finalizada:', error);
      return { success: false };
    }
  },

  // Obtener todas las respuestas de un candidato por token (incluye seccion_id, usado para restaurar progreso de Cleaver)
  getRespuestasByToken: async (token) => {
    try {
      const response = await axios.get(`${API_URL}/test/respuestas/token/${token}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener respuestas:', error);
      throw error.response?.data || { error: 'Error al cargar respuestas' };
    }
  },

  getReactivoById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/test/reactivos/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener reactivo:', error);
      return null;
    }
  },

  // Obtener configuración específica de Cleaver
  getCleaverConfig: async (pruebaId) => {
    try {
      const response = await axios.get(`${API_URL}/cleaver/config/${pruebaId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo configuración de Cleaver:', error);
      throw error;
    }
  },

  // Obtener secciones de Cleaver
  getCleaverSections: async (pruebaId) => {
    try {
      const response = await axios.get(`${API_URL}/cleaver/sections/${pruebaId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo secciones de Cleaver:', error);
      return [];
    }
  },

  // El candidato presiona "Comenzar": aquí se cobran los créditos de la
  // evaluación (una sola vez; reanudar no vuelve a cobrar). Si la empresa no
  // tiene créditos responde 402 con sin_creditos: true.
  iniciarTest: async (token) => {
    try {
      const response = await axios.post(`${API_URL}/test/iniciar`, { token });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'No se pudo iniciar la evaluación' };
    }
  },

  // Subir la foto de verificación del candidato (una sola vez por asignación)
  subirFoto: async (token, imagenBase64) => {
    try {
      const response = await axios.post(`${API_URL}/test/foto`, {
        token,
        imagen_base64: imagenBase64
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error al guardar la fotografía' };
    }
  },

  // Guardar puntuación por sección (para Cleaver)
  saveSectionScore: async (token, seccionId, puntaje, pruebaId) => {
    try {
      const response = await axios.post(`${API_URL}/cleaver/section-score`, {
        token,
        seccion_id: seccionId,
        puntaje,
        prueba_id: pruebaId
      });
      return response.data;
    } catch (error) {
      console.error('Error guardando puntuación de sección:', error);
      throw error.response?.data || { error: 'Error al guardar puntuación' };
    }
  }
};

export default testService;